module.exports = __webpack_public_path__ + "static/media/1.078d312d.jpg";